exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".obj-dialog[data-v-2bbd39eb]{background-image:var(--dialogBgImg);padding:20px}.obj-dialog[data-v-2bbd39eb],.obj-dialog .header[data-v-2bbd39eb]{background-repeat:no-repeat;background-size:100% 100%}.obj-dialog .header[data-v-2bbd39eb]{background-image:var(--diyCardTitleBg);height:36px;line-height:40px}", ""]);

// exports
